import IconList from 'components/common/IconList/IconList';
import React from 'react';
import {
  SPLASH_PAGE_FAQ,
  SplashPageContent1,
  SplashPageContent2,
} from 'src/common/constants';
import Accordion from 'src/components/common/Accordion/Accordion';
import './SplashPage.scss';

const SplashPage: React.FC = () => {
  return (
    <>
      <div className="b-typography-sans-serif--headline--50 b-font-weight-light">
        Some things to know:
      </div>
      <div className="splash-container">
        <div className="b-grid splash-section">
          <div className="content-left b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:8-col b-lg:8-col">
            <IconList title="A few things to keep in mind" data={SplashPageContent1} />
            <IconList title="What to expect" data={SplashPageContent2} />
          </div>
          <div className="b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:4-col b-lg:4-col">
            <div className="faq-container">
              <Accordion items={SPLASH_PAGE_FAQ} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SplashPage;
